import { ApolloQueryResult } from '@apollo/client';
import { get } from 'lodash';
import truncate from 'lodash/truncate';
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Stack, Text } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { FetchInvoiceGroupDetailsPpcQuery, EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { NoData } from '@css-xp/ppc-common';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { cardStyles, HeadingText } from './entitlement-cards.styles';

export type CompanyAndBillingProfileProps = {
  invoiceGroupDetails: ApolloQueryResult<FetchInvoiceGroupDetailsPpcQuery | undefined>;
  entitlement: EntitlementDetails;
};

export const CompanyAndBillingProfile = ({ invoiceGroupDetails, entitlement }: CompanyAndBillingProfileProps) => {
  const txaId = entitlement?.transactionAccountId ?? '';

  if (invoiceGroupDetails.loading) {
    return (
      <Box padding="space.200" xcss={cardStyles}>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="200px" marginBottom="0" />
        </SkeletonLoaderWrapper>
      </Box>
    );
  }

  const invoiceGroupName = get(invoiceGroupDetails, 'data.invoiceGroup.name', '');

  return (
    <Box padding="space.200" xcss={cardStyles}>
      <Stack space="space.100" alignBlock="center">
        <Text size="small" color="color.text.subtlest">
          Customer
        </Text>
        {invoiceGroupDetails.error && <NoData />}
        {!invoiceGroupDetails.error && (
          <>
            <HeadingText>{get(invoiceGroupDetails, 'data.invoiceGroup.shipToParty.name', '')}</HeadingText>
            <Tooltip tag="span" content={invoiceGroupName}>
              <Link
                to={`${getRouteUrl(routePaths.billingProfileDetails, {
                  txaId: txaId,
                  billingProfileId: `${get(invoiceGroupDetails, 'data.invoiceGroup.id', '')}`,
                })}`}
              >
                {truncate(invoiceGroupName, { length: 30 })}
              </Link>
            </Tooltip>
            <Text size="small" color="color.text.subtlest">
              {get(invoiceGroupDetails, 'data.invoiceGroup.invoiceGroupNumber', '')}
            </Text>
          </>
        )}
      </Stack>
    </Box>
  );
};
